export default __webpack_public_path__ + "static/media/guru.b0c3606c.md";